import type {Vsop87Element, Vsop87Group} from '@app/types/Vsop87Types';

const VSOP87_L0: Vsop87Element = [
    [0.87401354029],
    [0.1110765978, 3.96205090194, 213.299095438],
    [0.01414150958, 4.58581515873, 7.1135470008],
    [0.00398379386, 0.52112025957, 206.1855484372],
    [0.00350769223, 3.30329903015, 426.598190876],
    [0.00206816296, 0.24658366938, 103.0927742186],
    [0.00079271288, 3.8400707853, 220.4126424388],
    [0.00023990338, 4.6697693486, 110.2063212194],
    [0.00016573583, 0.43719123541, 419.4846438752],
    [0.000158203, 0.9380895376, 632.7837393132],
    [0.00015053509, 2.71670027883, 639.897286314],
    [0.00014906995, 5.76903283845, 316.3918696566],
    [0.00014609562, 1.56518573691, 3.9321532631],
    [0.00013160308, 4.44891180176, 14.2270940016],
    [0.00013005305, 5.98119067061, 11.0457002639],
    [0.00010725066, 3.12939596466, 202.2533951741],
    [0.00006126308, 1.76328499656, 277.0349937414],
    [0.00005863207, 0.23657028777, 529.6909650946],
    [0.00005227771, 4.2078316238, 3.1813937377],
    [0.00005019658, 3.17787919533, 433.7117378768],
    [0.00004592541, 0.61976424374, 199.0720014364],
    [0.00004005862, 2.24479893937, 63.7358983034],
    [0.00003873696, 3.22282692566, 138.5174968707],
    [0.0000326949, 0.77491895787, 949.1756089698],
    [0.00002953815, 0.98280385206, 95.9792272178],
    [0.00002461172, 2.03163631205, 735.8765135318],
    [0.00001758143, 3.26580514774, 522.5774180938],
    [0.00001640183, 5.50504966218, 846.0828347512],
    [0.00001580641, 4.3726631412, 309.2783226558],
    [0.00001391336, 4.02331978116, 323.5054166574],
    [0.00001123515, 2.83726793572, 415.5524906121],
    [0.00001087237, 4.18343232481, 2.4476805548],
    [0.00001017258, 3.71698151814, 227.5261894396],
    [0.00000956752, 0.50740889886, 1265.5674786264],
    [0.00000852677, 3.42141350697, 175.1660598002],
    [0.00000848643, 3.19149825839, 209.3669421749],
    [0.00000789205, 5.00745123149, 0.9632078465],
    [0.00000748811, 2.14398149298, 853.196381752],
    [0.00000743584, 5.25276954625, 224.3447957019],
    [0.00000686965, 1.74714407827, 1052.2683831884],
    [0.0000065447, 1.59889331515, 0.0481841098],
    [0.0000063398, 2.29889903023, 412.3710968744],
    [0.00000624904, 0.97046831256, 210.1177017003],
    [0.00000579857, 3.09259007048, 74.7815985673],
    [0.00000546358, 2.12678554211, 350.3321196004],
    [0.00000542643, 1.51824320514, 9.5612275556],
    [0.00000529861, 4.44938897119, 117.3198682202],
    [0.00000478054, 2.96488054338, 137.0330241624],
    [0.00000474279, 5.47527185987, 742.9900605326],
    [0.00000451827, 1.04436664241, 490.3340891794],
    [0.00000448542, 1.28990416161, 127.4717966068],
    [0.00000372308, 2.27819108625, 217.2312487011],
    [0.00000354944, 3.0128648303, 838.9692877504],
    [0.00000347413, 1.53928227764, 340.7708920448],
    [0.00000343475, 0.24604039134, 0.5212648618],
    [0.00000330196, 0.24715617844, 1581.959348283],
    [0.00000322185, 0.96137456104, 203.7378678824],
    [0.00000321543, 2.57182354537, 647.0108333148],
    [0.00000309001, 3.49486734909, 216.4804891757],
    [0.00000286688, 2.37043745859, 351.8165923087],
    [0.00000277775, 0.40020408926, 211.8146227297],
    [0.00000249116, 1.47010534421, 1368.660252845],
    [0.00000226609, 4.91003163138, 12.5301729722],
    [0.00000220225, 4.20422424873, 200.7689224658],
    [0.00000208655, 1.34516255304, 625.6701923124],
    [0.00000207663, 0.48349820488, 1162.4747044078],
    [0.00000207659, 1.283022189, 39.3568759152],
    [0.000002045, 6.010822066, 265.9892934775],
    [0.0000018469, 3.50344404958, 149.5631971346],
    [0.00000183511, 0.97254952728, 4.192785694],
    [0.00000182454, 5.49122292426, 2.9207613068],
    [0.00000173914, 1.86305806814, 0.7507595254],
    [0.00000164541, 0.4400551752, 5.4166259714],
    [0.00000149299, 5.73594349789, 52.6901980395],
    [0.00000147526, 1.53529320509, 5.6290742925],
    [0.00000146068, 6.23102544071, 195.1398481733],
    [0.00000139666, 4.29450260069, 21.3406410024],
    [0.00000131283, 4.06828961903, 10.2949407385],
    [0.00000124969, 6.27737805832, 1898.3512179396],
    [0.00000122373, 1.97588777199, 4.665866446],
];

const VSOP87_L1: Vsop87Element = [
    [213.54295595986],
    [0.01296855005, 1.82820544701, 213.299095438],
    [0.00564347566, 2.88500136429, 7.1135470008],
    [0.0010767877, 2.27769911872, 206.1855484372],
    [0.0009832303, 1.08070061328, 426.598190876],
    [0.00040254586, 2.0412825709, 220.4126424388],
    [0.00019941734, 1.27954662736, 103.0927742186],
    [0.00010511706, 2.748803928, 14.2270940016],
    [0.00006939233, 0.40493079985, 639.897286314],
    [0.00004803325, 2.44194097666, 419.4846438752],
    [0.00004056325, 2.92166618776, 110.2063212194],
    [0.0000376863, 3.6496563146, 3.9321532631],
    [0.00003384684, 2.41694251653, 3.1813937377],
    [0.000033022, 1.26256486715, 433.7117378768],
    [0.00003071382, 2.3273931775, 199.0720014364],
    [0.00001953036, 3.563946833, 11.0457002639],
    [0.00001249348, 2.62803737519, 95.9792272178],
    [0.00000921683, 1.9608983425, 227.5261894396],
    [0.00000705587, 4.4168924933, 529.6909650946],
    [0.00000649654, 6.17418093659, 202.2533951741],
    [0.00000627603, 6.11088227167, 309.2783226558],
    [0.00000486843, 6.03998200305, 853.196381752],
    [0.00000478501, 4.98776987984, 522.5774180938],
    [0.00000468377, 4.61707843907, 63.7358983034],
    [0.0000041701, 2.11708169277, 323.5054166574],
    [0.0000040763, 1.29949556676, 209.3669421749],
    [0.00000352489, 2.31707079463, 632.7837393132],
    [0.00000343826, 3.95854178574, 412.3710968744],
    [0.00000339724, 3.63396398752, 316.3918696566],
    [0.00000335936, 3.77173072712, 735.8765135318],
    [0.00000331933, 2.86077699882, 210.1177017003],
    [0.00000289429, 2.73263080235, 117.3198682202],
    [0.00000280911, 5.74398845416, 2.4476805548],
    [0.00000265801, 0.54344631312, 647.0108333148],
    [0.00000230493, 1.64428879621, 216.4804891757],
    [0.00000191667, 2.96512946582, 224.3447957019],
    [0.00000172891, 4.07695221044, 846.0828347512],
    [0.00000167131, 2.59745202658, 21.3406410024],
    [0.00000136328, 2.28580246629, 10.2949407385],
    [0.00000131364, 3.44108355646, 742.9900605326],
    [0.00000127838, 4.09533471247, 217.2312487011],
    [0.00000108862, 6.16141072262, 415.5524906121],
    [0.00000097584, 4.72845436677, 838.9692877504],
    [0.00000093909, 3.48397279899, 1052.2683831884],
    [0.00000092482, 3.94755499926, 88.865680217],
    [0.000000866, 1.21951325061, 440.8252848776],
    [0.00000083463, 3.11269504725, 625.6701923124],
];

const VSOP87_L2: Vsop87Element = [
    [0.00116441181, 1.17987850633, 7.1135470008],
    [0.00091920844, 0.07425261094, 213.299095438],
    [0.00090592251],
    [0.00015276909, 4.06492007503, 206.1855484372],
    [0.00010631396, 0.25778277414, 220.4126424388],
    [0.00010604979, 5.40963595885, 426.598190876],
    [0.00004265368, 1.0459555663, 14.2270940016],
    [0.00001215527, 2.91860042123, 103.0927742186],
    [0.00001164684, 4.60942128971, 639.897286314],
    [0.00001081967, 5.6913035167, 433.7117378768],
    [0.00001044754, 4.04206453611, 199.0720014364],
    [0.00001020079, 0.63369182642, 3.1813937377],
    [0.00000633582, 4.38825410036, 419.4846438752],
    [0.00000549329, 5.57303134242, 3.9321532631],
    [0.00000456914, 1.26840971349, 110.2063212194],
    [0.000004251, 0.20935499279, 227.5261894396],
    [0.00000273739, 4.28841011784, 95.9792272178],
    [0.00000161571, 1.3813914942, 11.0457002639],
    [0.00000129494, 1.5658688417, 309.2783226558],
    [0.00000117008, 3.88120915956, 853.196381752],
    [0.00000105415, 4.90003203599, 647.0108333148],
    [0.00000100967, 0.892704931, 21.3406410024],
    [0.00000095659, 2.91093561539, 316.3918696566],
    [0.00000095227, 5.62561150598, 412.3710968744],
    [0.0000008486, 5.73472777961, 209.3669421749],
    [0.00000082727, 6.05030934786, 216.4804891757],
    [0.00000081948, 1.02477558315, 117.3198682202],
    [0.00000074857, 4.76178468163, 210.1177017003],
    [0.00000067184, 0.45648612616, 522.5774180938],
    [0.00000066459, 0.48297940601, 10.2949407385],
    [0.00000063696, 0.35179804917, 323.5054166574],
    [0.00000060647, 4.8751785019, 632.7837393132],
    [0.00000053281, 2.74730541387, 529.6909650946],
    [0.00000045827, 5.69296621745, 440.8252848776],
    [0.00000045293, 1.66856699796, 202.2533951741],
    [0.0000004233, 5.70768187703, 88.865680217],
    [0.0000003214, 0.07050050346, 63.7358983034],
];

const VSOP87_L3: Vsop87Element = [
    [0.00016038734, 5.73945377424, 7.1135470008],
    [0.00004249793, 4.58539675603, 213.299095438],
    [0.00001906524, 4.76082050205, 220.4126424388],
    [0.00001465687, 5.91326678323, 206.1855484372],
    [0.00001162041, 5.61973132428, 14.2270940016],
    [0.00001066581, 3.60816533142, 426.598190876],
    [0.00000239377, 3.86088273439, 433.7117378768],
    [0.00000236975, 5.76826451465, 199.0720014364],
    [0.00000165641, 5.11641150216, 3.1813937377],
    [0.00000151352, 2.73594641861, 639.897286314],
    [0.00000131409, 4.74327544615, 227.5261894396],
    [0.00000063365, 0.22850089497, 419.4846438752],
    [0.0000006163, 4.74287052463, 103.0927742186],
    [0.00000040437, 5.47298059144, 21.3406410024],
    [0.00000040205, 5.9642026672, 95.9792272178],
    [0.00000038746, 5.83386199529, 110.2063212194],
    [0.00000028025, 3.01235311514, 647.0108333148],
    [0.00000025029, 0.9880817074, 3.9321532631],
    [0.00000019014, 1.91614237463, 853.196381752],
    [0.00000018262, 4.96738415934, 10.2949407385],
    [0.00000018101, 1.02506397063, 412.3710968744],
    [0.00000017919, 4.20376505349, 216.4804891757],
];

const VSOP87_L4: Vsop87Element = [
    [0.00001661894, 3.99826248978, 7.1135470008],
    [0.00000257107, 2.98436499013, 220.4126424388],
    [0.00000236344, 3.90241428075, 14.2270940016],
    [0.00000149418, 2.74110824208, 213.299095438],
    [0.00000109598, 1.51515739251, 206.1855484372],
    [0.0000006839, 1.72120953337, 426.598190876],
    [0.0000004006, 2.04644897412, 433.7117378768],
    [0.00000037699, 1.23795458356, 199.0720014364],
    [0.00000031219, 3.0109418409, 227.5261894396],
];

const VSOP87_L5: Vsop87Element = [
    [0.00000123615, 2.25923345732, 7.1135470008],
    [0.0000003419, 2.16250652689, 14.2270940016],
];

const VSOP87_B0: Vsop87Element = [
    [0.0433067804, 3.60284428399, 213.299095438],
    [0.00240348303, 2.8523848939, 426.598190876],
    [0.00084745939],
    [0.00034116063, 0.57297307844, 206.1855484372],
    [0.00030863357, 3.48441504465, 220.4126424388],
    [0.0001473407, 2.1184659787, 639.897286314],
    [0.00009916668, 5.79003189405, 419.4846438752],
    [0.00006993564, 4.73604689179, 7.1135470008],
    [0.00004807587, 5.43305315602, 316.3918696566],
    [0.00004788392, 4.9651292742, 110.2063212194],
    [0.00003432125, 2.73255752123, 433.7117378768],
    [0.00001506129, 6.01304536144, 103.0927742186],
    [0.00001060298, 5.63099292414, 529.6909650946],
    [0.00000969071, 5.20434966103, 632.7837393132],
    [0.0000094205, 1.39646678088, 853.196381752],
    [0.00000707645, 3.80302329547, 323.5054166574],
    [0.00000552313, 5.13149109045, 202.2533951741],
    [0.00000399675, 3.35891413961, 227.5261894396],
    [0.0000031938, 3.6257155098, 209.3669421749],
    [0.00000316063, 1.99716764199, 647.0108333148],
    [0.00000314225, 0.4651027241, 217.2312487011],
    [0.00000284494, 4.88648481625, 224.3447957019],
    [0.00000236442, 2.13887472281, 11.0457002639],
    [0.00000215354, 5.94982610103, 846.0828347512],
    [0.00000208522, 2.12003893769, 415.5524906121],
    [0.00000207213, 0.73021462851, 199.0720014364],
    [0.00000178958, 2.95361514672, 63.7358983034],
    [0.00000140585, 0.64417620299, 490.3340891794],
    [0.0000013924, 4.59535168021, 14.2270940016],
    [0.0000013914, 1.9982199094, 735.8765135318],
    [0.00000134884, 5.24500819605, 742.9900605326],
    [0.00000121669, 3.11537140876, 522.5774180938],
    [0.00000115524, 3.10891547171, 216.4804891757],
    [0.00000114218, 0.96261442133, 210.1177017003],
    [0.00000096376, 4.48164339766, 117.3198682202],
    [0.00000080593, 1.3169275015, 277.0349937414],
    [0.00000074302, 2.8937653962, 149.5631971346],
    [0.00000072952, 3.0598848237, 536.8045120954],
    [0.00000069261, 4.92378633635, 309.2783226558],
    [0.0000006804, 2.18002263974, 351.8165923087],
    [0.00000061734, 0.67728106562, 1066.49547719],
    [0.00000056598, 2.60963391288, 440.8252848776],
    [0.00000048864, 5.78725874107, 95.9792272178],
];

const VSOP87_B1: Vsop87Element = [
    [0.00397554998, 5.33289992556, 213.299095438],
    [0.00018571607, 6.09919206378, 426.598190876],
    [0.00014800587, 2.3058606052, 206.1855484372],
    [0.00009643981, 1.6967466012, 220.4126424388],
    [0.00003757161, 1.25429514018, 419.4846438752],
    [0.00002716647, 5.91166664787, 639.897286314],
    [0.00001455309, 0.85161616532, 433.7117378768],
    [0.00001290595, 2.9177085709, 7.1135470008],
    [0.0000085263, 0.43572078997, 316.3918696566],
    [0.00000297726, 0.91909206723, 632.7837393132],
    [0.00000292185, 5.3157425127, 853.196381752],
    [0.00000284386, 1.61881754773, 227.5261894396],
    [0.0000027509, 3.88864137336, 103.0927742186],
    [0.00000172359, 0.05215146556, 647.0108333148],
    [0.00000166237, 2.44351613165, 199.0720014364],
    [0.0000015822, 5.20850125766, 110.2063212194],
    [0.00000127731, 1.20711452525, 529.6909650946],
    [0.00000109839, 2.45695551627, 217.2312487011],
    [0.00000081759, 2.75839171353, 210.1177017003],
    [0.0000008101, 2.86038377187, 14.2270940016],
    [0.00000068658, 1.65537623146, 202.2533951741],
    [0.00000065161, 1.25527521313, 216.4804891757],
    [0.00000061024, 1.25273412095, 209.3669421749],
    [0.00000059281, 1.82410768234, 323.5054166574],
    [0.00000046386, 0.81534705304, 440.8252848776],
    [0.00000036163, 1.81851057689, 224.3447957019],
];

const VSOP87_B2: Vsop87Element = [
    [0.00020629977, 0.50482422817, 213.299095438],
    [0.00003719555, 3.99833475829, 206.1855484372],
    [0.00001627158, 6.181899395, 220.4126424388],
    [0.00001346067],
    [0.00000705842, 3.03914308836, 419.4846438752],
    [0.00000365042, 5.09928680706, 426.598190876],
    [0.00000329632, 5.27899210039, 433.7117378768],
    [0.00000219335, 3.82841533795, 639.897286314],
    [0.00000139393, 1.04272623499, 7.1135470008],
    [0.0000010398, 6.15730992966, 227.5261894396],
    [0.00000092961, 1.97994412845, 316.3918696566],
    [0.00000071242, 4.14754353431, 199.0720014364],
    [0.00000051927, 2.88364833898, 632.7837393132],
    [0.00000048961, 4.43390206741, 647.0108333148],
    [0.00000041373, 3.15927770079, 853.196381752],
    [0.00000028602, 4.52978327558, 210.1177017003],
    [0.00000023969, 1.11595912146, 14.2270940016],
    [0.00000020511, 4.35095844197, 217.2312487011],
];

const VSOP87_B3: Vsop87Element = [
    [0.00000666252, 1.99006340181, 213.299095438],
    [0.0000063235, 5.69778316807, 206.1855484372],
    [0.00000398051],
    [0.00000187838, 4.33779804809, 220.4126424388],
    [0.00000091884, 4.84104208217, 419.4846438752],
    [0.00000051548, 3.42149490328, 433.7117378768],
    [0.00000042369, 2.38073239056, 426.598190876],
    [0.00000025661, 4.40167213109, 227.5261894396],
];

const VSOP87_B4: Vsop87Element = [
    [0.00000080384, 1.11918414679, 206.1855484372],
    [0.0000003166, 3.12218745098, 213.299095438],
];

const VSOP87_B5: Vsop87Element = [];

const VSOP87_R0: Vsop87Element = [
    [9.55758135801],
    [0.52921382465, 2.39226219733, 213.299095438],
    [0.01873679934, 5.23549605091, 206.1855484372],
    [0.01464663959, 1.64763045468, 426.598190876],
    [0.00821891059, 5.93520025371, 316.3918696566],
    [0.00547506899, 5.01532628454, 103.0927742186],
    [0.00371684449, 2.27114833428, 220.4126424388],
    [0.00361778433, 3.13904303264, 7.1135470008],
    [0.00140617548, 5.70406652991, 632.7837393132],
    [0.00108974737, 3.29313595577, 110.2063212194],
    [0.00069007015, 5.94099622447, 419.4846438752],
    [0.0006105335, 0.94037761156, 639.897286314],
    [0.00048913044, 1.55733388472, 202.2533951741],
    [0.00034143794, 0.19518550682, 277.0349937414],
    [0.00032401718, 5.47084606947, 949.1756089698],
    [0.00020936573, 0.46349163993, 735.8765135318],
    [0.00020839118, 1.5210259064, 433.7117378768],
    [0.00020746678, 5.33255667599, 199.0720014364],
    [0.00015298457, 3.05943652881, 529.6909650946],
    [0.00014296479, 2.60433537909, 323.5054166574],
    [0.00012884128, 1.64892310393, 138.5174968707],
    [0.00011993314, 5.98051421881, 846.0828347512],
    [0.00011380261, 1.73105746566, 522.5774180938],
    [0.00009796061, 5.20475863996, 1265.5674786264],
    [0.00007752769, 5.85191318903, 95.9792272178],
    [0.00006770621, 3.00433479284, 14.2270940016],
    [0.00006465967, 0.17733160145, 1052.2683831884],
    [0.00005850443, 1.45519636076, 415.5524906121],
    [0.00005307481, 0.5973753405, 63.7358983034],
    [0.00004695746, 2.14919036956, 227.5261894396],
    [0.00004043988, 1.64010323863, 209.3669421749],
    [0.00003688132, 0.7801613317, 412.3710968744],
    [0.00003460943, 1.85088802878, 175.1660598002],
    [0.00003419551, 4.94549148887, 1581.959348283],
    [0.00003400616, 0.55386747515, 350.3321196004],
    [0.00003376457, 3.69528478828, 224.3447957019],
    [0.00002976033, 5.68467931117, 210.1177017003],
    [0.00002885348, 1.38764077631, 838.9692877504],
    [0.00002881181, 0.17960757891, 853.196381752],
    [0.0000250763, 3.53851863255, 742.9900605326],
    [0.00002448325, 6.18412386316, 1368.660252845],
    [0.00002406138, 2.96559220267, 117.3198682202],
    [0.00002173959, 0.01508587396, 340.7708920448],
    [0.00002024483, 5.05411271271, 11.0457002639],
    [0.00001888436, 0.02968443389, 3.9321532631],
    [0.00001861397, 5.93361638244, 625.6701923124],
    [0.00001817186, 5.77713225779, 490.3340891794],
    [0.00001781165, 0.76314388077, 217.2312487011],
    [0.00001740254, 2.34657043464, 309.2783226558],
    [0.00001610859, 1.17302463549, 74.7815985673],
    [0.00001474547, 5.6767046113, 203.7378678824],
    [0.00001472392, 1.40064915651, 137.0330241624],
    [0.00001462631, 1.92588134017, 216.4804891757],
    [0.00001395109, 5.93669404929, 127.4717966068],
    [0.00001315042, 5.11202572637, 211.8146227297],
    [0.00001304089, 0.77235613966, 647.0108333148],
    [0.00001295553, 4.69184139933, 1898.3512179396],
    [0.00001277489, 2.98412586423, 1059.3819301892],
    [0.00001207053, 0.7528593316, 351.8165923087],
    [0.00001149773, 5.74021249703, 1162.4747044078],
];

const VSOP87_R1: Vsop87Element = [
    [0.06182981282, 0.25843515034, 213.299095438],
    [0.00506577574, 0.71114650941, 206.1855484372],
    [0.00341394136, 5.7963577396, 426.598190876],
    [0.00188491375, 0.47215719444, 220.4126424388],
    [0.00143891176, 1.40744864239, 7.1135470008],
    [0.00049621111, 6.0174446958, 103.0927742186],
    [0.00020928189, 5.0924565447, 639.897286314],
    [0.00019952612, 1.17560125007, 419.4846438752],
    [0.00018839639, 1.60819563173, 110.2063212194],
    [0.00013876565, 0.75886204364, 199.0720014364],
    [0.00012892827, 5.94330258435, 433.7117378768],
    [0.00005396699, 1.28852405908, 14.2270940016],
    [0.00004869308, 0.86793894213, 323.5054166574],
    [0.00004247455, 0.39299384543, 227.5261894396],
    [0.00003252084, 1.25853470491, 95.9792272178],
    [0.00003081408, 3.43662557418, 522.5774180938],
    [0.00002909411, 4.60679154788, 202.2533951741],
    [0.00002856006, 2.16731405366, 735.8765135318],
    [0.00001987689, 2.45054204795, 412.3710968744],
    [0.00001941309, 6.02393385142, 209.3669421749],
    [0.00001581446, 1.29191789712, 210.1177017003],
    [0.00001339511, 4.30801821806, 853.196381752],
    [0.0000131559, 1.25296446023, 117.3198682202],
    [0.00001203085, 1.86654673794, 316.3918696566],
    [0.00001091088, 0.07527246854, 216.4804891757],
    [0.00000966012, 0.47991379141, 632.7837393132],
    [0.00000954403, 5.15173410519, 647.0108333148],
    [0.00000897512, 0.98343776092, 529.6909650946],
    [0.00000881827, 1.88471724478, 1052.2683831884],
    [0.00000874215, 1.40224683864, 224.3447957019],
    [0.00000784866, 3.06377517461, 838.9692877504],
    [0.00000739892, 1.38225356694, 625.6701923124],
    [0.0000065821, 4.1436293098, 309.2783226558],
    [0.000006496, 1.7248948616, 742.9900605326],
    [0.00000612961, 3.03307306767, 63.7358983034],
    [0.00000599236, 2.54924174765, 217.2312487011],
    [0.00000502886, 2.12958819475, 3.9321532631],
    [0.00000413017, 4.59334402271, 415.5524906121],
    [0.00000395004, 0.53349091102, 956.2891559706],
    [0.00000362772, 4.70691652867, 302.164775655],
    [0.00000356117, 2.30312127651, 728.762966531],
    [0.00000344777, 5.88787577835, 440.8252848776],
];

const VSOP87_R2: Vsop87Element = [
    [0.00436902464, 4.78671673044, 213.299095438],
    [0.0007192276, 2.50069994874, 206.1855484372],
    [0.00049766792, 4.9716815087, 220.4126424388],
    [0.00043220894, 3.86940443794, 426.598190876],
    [0.00029645554, 5.96310264282, 7.1135470008],
    [0.00004720909, 2.47527992423, 199.0720014364],
    [0.0000414165, 4.10670940823, 433.7117378768],
    [0.0000378937, 3.09771025067, 639.897286314],
    [0.0000296399, 1.37206248846, 103.0927742186],
    [0.00002556363, 2.85065721526, 419.4846438752],
    [0.00002326801],
    [0.00002208457, 6.27588858707, 110.2063212194],
    [0.00002187621, 5.85545832218, 14.2270940016],
    [0.00001956896, 4.92448618045, 227.5261894396],
    [0.0000092384, 5.46392422737, 323.5054166574],
    [0.00000705936, 2.97081280098, 95.9792272178],
    [0.00000546115, 4.12854181522, 412.3710968744],
    [0.00000431485, 5.17825414612, 522.5774180938],
    [0.00000405018, 4.17294157872, 209.3669421749],
    [0.00000390627, 4.48106176893, 216.4804891757],
    [0.00000373838, 5.83435991809, 117.3198682202],
    [0.00000360882, 3.27703082368, 647.0108333148],
    [0.0000035635, 3.19152043942, 210.1177017003],
    [0.00000325598, 2.26867601656, 853.196381752],
    [0.00000206854, 4.02188336738, 735.8765135318],
    [0.00000204494, 0.0877484859, 202.2533951741],
    [0.00000180143, 3.59704903955, 632.7837393132],
    [0.00000178474, 4.09716541453, 440.8252848776],
];

const VSOP87_R3: Vsop87Element = [
    [0.00020315005, 3.02186626038, 213.299095438],
    [0.00008923581, 3.19144205755, 220.4126424388],
    [0.00006908677, 4.35174889353, 206.1855484372],
    [0.00004087129, 4.22406927376, 7.1135470008],
    [0.00003879041, 2.01056445995, 426.598190876],
    [0.00001070788, 4.20360341236, 199.0720014364],
    [0.00000907332, 2.28344368029, 433.7117378768],
    [0.00000606121, 3.17458570534, 227.5261894396],
    [0.00000596639, 4.13455753351, 14.2270940016],
    [0.00000483181, 1.17345973258, 639.897286314],
    [0.00000393174],
    [0.00000229472, 4.69838526383, 419.4846438752],
    [0.0000018825, 4.59003889007, 110.2063212194],
];

const VSOP87_R4: Vsop87Element = [
    [0.0000120205, 1.41499446465, 220.4126424388],
    [0.00000707796, 1.16153570102, 213.299095438],
    [0.00000516121, 6.2397356833, 206.1855484372],
    [0.00000426664, 2.46924890293, 7.1135470008],
];

const VSOP87_R5: Vsop87Element = [[0.00000128612, 5.91282565136, 220.4126424388]];

export const VSOP87_X: Vsop87Group = [VSOP87_L0, VSOP87_L1, VSOP87_L2, VSOP87_L3, VSOP87_L4, VSOP87_L5];
export const VSOP87_Y: Vsop87Group = [VSOP87_B0, VSOP87_B1, VSOP87_B2, VSOP87_B3, VSOP87_B4, VSOP87_B5];
export const VSOP87_Z: Vsop87Group = [VSOP87_R0, VSOP87_R1, VSOP87_R2, VSOP87_R3, VSOP87_R4, VSOP87_R5];
